export const BASE_URL = 'https://serpdata.coming-soon.xyz';
export const LOCAL_STORAGE_KEY = 'prospect_pug';
// export const BASE_URL = 'http://127.0.0.1:8000';

export const PREVIEW_EXCEL_ERROR_MESSAGE = 'Could not fetch file. Please try again later.';
export const DOWNLOAD_EXCEL_ERROR_MESSAGE = 'Could not download file. Please try again later.';
